import React, {useRef, useEffect} from 'react'
import {useLocation, useNavigate} from 'react-router'
import {AsideMenuMain} from './AsideMenuMain'
import { DrawerComponent, ScrollComponent, ToggleComponent } from '../../../assets/ts/components'
import { getAuthRoles, setActiveRole } from '../../../../app/modules/auth/core/AuthHelpers'

type Props = {
  asideMenuCSSClasses: string[]
  hideMenuContent?: boolean
}

const AsideMenu: React.FC<Props> = ({asideMenuCSSClasses, hideMenuContent = false}) => {
  const scrollRef = useRef<HTMLDivElement | null>(null)
    const { pathname } = useLocation()
    const navigate = useNavigate()
    const authRoles = getAuthRoles(); // Kullanıcının rollerini ve token'larını al

  useEffect(() => {
    setTimeout(() => {
      DrawerComponent.reinitialization()
      ToggleComponent.reinitialization()
      ScrollComponent.reinitialization()
      if (scrollRef.current) {
        scrollRef.current.scrollTop = 0
      }
    }, 50)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname])

    // Rol değiştirildiğinde çağrılacak fonksiyon
    const handleChangeRole = (index: number) => {
        // Önce dashboard'a yönlendir
        navigate('/dashboard')

        // Ardından rolü değiştir ve sayfayı yenile
        setTimeout(() => {
            setActiveRole(index)
            window.location.reload()
        }, 0)
    }

  return (
    <div
      id='kt_aside_menu_wrapper'
      ref={scrollRef}
      className='w-100 hover-scroll-overlay-y d-flex pe-2'
      data-kt-scroll='true'
      data-kt-scroll-activate='{default: false, lg: true}'
      data-kt-scroll-height='auto'
      data-kt-scroll-dependencies='#kt_aside_logo, #kt_aside_footer'
      data-kt-scroll-wrappers='#kt_aside, #kt_aside_menu, #kt_aside_menu_wrapper'
      data-kt-scroll-offset='100'
    >
      <div
        id='#kt_aside_menu'
        data-kt-menu='true'
        className='menu menu-column menu-rounded fw-bold my-auto'
      >
        {!hideMenuContent && (
          <>
            {(authRoles?.roles?.length !== undefined && authRoles?.roles?.length > 1) && (
              <div className='menu-item px-5'>
                <div className='menu-content'>
                  <select
                    className='form-select'
                    onChange={(e) => handleChangeRole(parseInt(e.target.value, 10))}
                    defaultValue='Rol Seçin'
                  >
                    <option disabled>Rol Seçin</option>
                    {authRoles?.roles.map((role, index) => (
                      <option key={index} value={index}>
                        {role.role}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            )}
            <AsideMenuMain />
          </>
        )}
      </div>
    </div>
  )
}

export {AsideMenu}
